import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { UseFormReturnType } from '@mantine/form';

import { CreditRequestBasicForm, CreditOptionsResponse, CreditResponse } from 'types';

interface CreditRequestFormContextType {
  form: UseFormReturnType<CreditRequestBasicForm>;
  isSubmitted: boolean;
  setIsSubmitted: Dispatch<SetStateAction<boolean>>;
  options: CreditOptionsResponse | undefined;
  setActiveStep: Dispatch<SetStateAction<number>>;
  currentCredit: Partial<CreditResponse>;
  setCurrentCredit: Dispatch<SetStateAction<Partial<CreditResponse>>>;
  isEditable: boolean;
  setIsEditable: Dispatch<SetStateAction<boolean>>;
}

export const CreditRequestFormContext = createContext<CreditRequestFormContextType | undefined>(undefined);

export const useCreditRequestForm = () => {
  const context = useContext(CreditRequestFormContext);
  if (!context) {
    throw new Error('useCreditRequest must be used within a CreditRequestProvider');
  }
  return context;
};